import { DialogId, DialogSchema } from '@feedyou/schema'
import { getUsedDialogs } from '../../../components/steps/utils/stepServices/stepServices'

export function getDirectSubdialogsForDialog(dialog: DialogSchema): Set<DialogId> {
  return new Set(dialog.steps?.flatMap(step => getUsedDialogs(step, false)))
}

export function getDirectEnabledSubdialogsForDialog(dialog: DialogSchema): Set<DialogId> {
  return new Set(dialog.steps?.flatMap(step => getUsedDialogs(step, true)))
}
